module.exports = __webpack_public_path__ + "sbcr_modal_logo.svg?6c42b5d01be3e4bb03a3961fc9bda6ac";